import * as React from "react";

const LinkButton = (props: any) => (
  <svg width={64} height={64} viewBox="0 0 64 64" {...props}>
    <g fill="none" fillRule="evenodd">
      <path fill="#7B838C" d="M8 21.75h48v20H8z" />
      <path
        d="M28.732 29.844c-.48-.528-1.07-.792-1.77-.792s-1.29.264-1.77.792-.72 1.166-.72 1.914.24 1.384.72 1.908 1.07.786 1.77.786 1.29-.262 1.77-.786.72-1.16.72-1.908-.24-1.386-.72-1.914zm-1.776 6.24c-1.24 0-2.284-.414-3.132-1.242-.848-.828-1.272-1.858-1.272-3.09 0-1.232.424-2.262 1.272-3.09.848-.828 1.892-1.242 3.132-1.242 1.24 0 2.284.414 3.132 1.242.848.828 1.272 1.858 1.272 3.09 0 1.232-.424 2.262-1.272 3.09-.848.828-1.892 1.242-3.132 1.242zm6.088-8.472h1.872v3.444l3.168-3.444H40.4l-3.336 3.708c.288.4.82 1.146 1.596 2.238A857.535 857.535 0 0 0 40.4 36h-2.184l-2.46-3.312-.84.936V36h-1.872v-8.388z"
        fill="#FFF"
      />
      <path d="M20.5 38.5h22" stroke="#FFF" strokeLinecap="square" />
    </g>
  </svg>
);

export default LinkButton;

